const legalForms = [
    "ASSO",
    "CE",
    "CL",
    "CNE",
    "COOP",
    "CUMA",
    "DPT",
    "EARL",
    "EC",
    "EI",
    "EIRL",
    "ETRANGER",
    "EURL",
    "FEDE",
    "FOND",
    "GAEC",
    "GEIE",
    "GF",
    "GFA",
    "GFR",
    "GIE",
    "GPT",
    "GREFFE",
    "IND",
    "MUT",
    "SA",
    "SAE",
    "SARL",
    "SAS",
    "SASU",
    "SC",
    "SCA",
    "SCCV",
    "SCE",
    "SCEA",
    "SCEV",
    "SCH",
    "SCI",
    "SCM",
    "SCP",
    "SCPG",
    "SCPI",
    "SCS",
    "SCVV",
    "SDE",
    "SELARL",
    "SNC",
];
const excludedWords = [
    "AU",
    "DU",
    "DE",
    "DES",
    "D",
    "ET",
    "LE",
    "LA",
    "LES",
    "POUR",
    "UN",
    "UNE",
    "L",
    "MON",
    "MA",
    "MES",
    "A",
    "INC",
    "CORP",
    "LTD",
    "&CO",
    "CO",
];

import softwareExportFormats from "./softwareExportFormats.json";
export class ExportFECServices {
    dicoThirdPartyAuxNums = {};
    dicoAuxNums = {};

    customerPrefix = "V_";
    supplierPrefix = "A_";
    aa421Suffix = "PA_";
    aa425Suffix = "ND_";
    aa455Suffix = "CO_";
    aa467Suffix = "DC_";
    auxiliaryCharacterCount = 10;

    accountableAccountCharacterCount = 9;
    minAccountableAccountCharacterCount = 6;
    accountableAccountWithUserAsSubAccount: boolean = false;

    enableUserNames = true;
    enableAuxilaryNames = true;
    enableAccAccNames = true;
    dbMapping = {
        customerPrefix: "V_",
        supplierPrefix: "A_",
        aa421Suffix: "PA_",
        aa425Suffix: "ND_",
        aa455Suffix: "CO_",
        aa467Suffix: "DC_",
        auxiliaryCharacterCount: 10,
        accountableAccountCharacterCount: 9,
    };

    accountableAccounts = {};
    users = {};
    auxiliaries = {};
    bankAccounts = {};

    softwareExport = softwareExportFormats.unknown;

    constructor(options, mapping) {
        this.customerPrefix = options.customerPrefix || "V_";
        this.supplierPrefix = options.supplierPrefix || "A_";
        this.aa421Suffix = options.aa421Suffix || "PA_";
        this.aa425Suffix = options.aa425Suffix || "ND_";
        this.aa455Suffix = options.aa455Suffix || "CO_";
        this.aa467Suffix = options.aa467Suffix || "DC_";
        this.auxiliaryCharacterCount =
            options.auxiliaryCharacterCount || this.auxiliaryCharacterCount;
        this.accountableAccountWithUserAsSubAccount =
            options.accountableAccountWithUserAsSubAccount !== undefined
                ? options.accountableAccountWithUserAsSubAccount
                : false;
        if (options?.accountableAccountCharacterCount !== undefined) {
            this.accountableAccountCharacterCount =
                options.accountableAccountCharacterCount > 6
                    ? options.accountableAccountCharacterCount
                    : this.minAccountableAccountCharacterCount;
        }
        if (mapping) {
            if (Object.keys(mapping).length) {
                this.dbMapping = { ...mapping };
                if (mapping.accountableAccounts) {
                    this.accountableAccounts = mapping.accountableAccounts;
                }
                if (mapping.users) {
                    this.users = mapping.users;
                }
                if (mapping.auxiliaries) {
                    this.auxiliaries = mapping.auxiliaries;
                }
                if (mapping.bankAccounts) {
                    this.bankAccounts = mapping.bankAccounts;
                }
            }
        }

        if (options.softwareExport) {
            this.softwareExport = softwareExportFormats[options.softwareExport];
            if (this.softwareExport.CompteNum !== 1e3) {
                this.accountableAccountCharacterCount = this.softwareExport.CompteNum;
            }
            if (this.softwareExport.CompAuxNum !== 1e3) {
                this.auxiliaryCharacterCount = this.softwareExport.CompAuxNum;
            }
        }
    }

    getAuxNum(wording, maxCharacterCount) {
        if (!wording) {
            debugger;
            return "";
        }
        let num = this.dicoThirdPartyAuxNums[wording];
        if (num) {
            return num;
        }
        let workingWording = wording;
        workingWording = workingWording.replace(/\./g, "");
        const words = workingWording.match(/([^ '-]{1,})/g);
        if (!words) {
            debugger;
            return wording;
        }

        if (words.length > 1) {
            if (legalForms.indexOf(words[0].toUpperCase()) !== -1) {
                words.splice(0, 1);
            }

            if (words.length > 1) {
                for (let wi = words.length - 1; wi >= 0; wi--) {
                    if (excludedWords.indexOf(words[wi].toUpperCase()) !== -1) {
                        words.splice(wi, 1);
                        if (words.length === 1) {
                            break;
                        }
                    }
                }
            }
        }
        let characterCount = 0;
        characterCount = Math.trunc(maxCharacterCount / words.length);
        while (characterCount === 0 && words.length) {
            words.splice(words.length - 1, 1);
            characterCount = Math.trunc(maxCharacterCount / words.length);
        }

        let diff = maxCharacterCount - characterCount * words.length;

        num = "";
        for (const word of words) {
            const subString = word.substring(0, characterCount + diff);
            diff = characterCount + diff - subString.length;
            num += subString;
        }

        num = num.toLowerCase();

        const dict = {
            á: "a",
            â: "a",
            à: "a",
            é: "e",
            è: "e",
            ë: "e",
            î: "i",
            ï: "i",
            ô: "o",
            ù: "u",
            û: "u",
            ç: "c",
        };

        num = num.replace(/[^\w ]/g, (char) => dict[char] || char);

        num = num.toUpperCase();

        let index = 1;
        let initialString = num;
        while (this.dicoAuxNums[num]) {
            const indexS = index.toString();
            num = num.substring(0, num.length - indexS.length) + indexS;
            index++;
        }
        this.dicoThirdPartyAuxNums[wording] = num;
        this.dicoAuxNums[num] = true;

        return num;
    }

    getAuxiliaryAccountFromAccountingLine(accountingLine) {
        const auxiliaryAccount = {
            id: "",
            num: "",
            wording: "",
        };
        if (accountingLine.thirdPartyCompany) {
            if (accountingLine.accountableAccount.name.startsWith("401")) {
                auxiliaryAccount.num =
                    this.supplierPrefix +
                    this.getAuxiliaryAccountFromThirdPartyCompany(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.supplierPrefix.length
                    );
            } else if (accountingLine.accountableAccount.name.startsWith("411")) {
                auxiliaryAccount.num =
                    this.customerPrefix +
                    this.getAuxiliaryAccountFromThirdPartyCompany(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.customerPrefix.length
                    );
            }
        } else if (accountingLine.user && !this.accountableAccountWithUserAsSubAccount) {
            if (accountingLine.accountableAccount.name.startsWith("421")) {
                auxiliaryAccount.num =
                    this.aa421Suffix +
                    this.getAuxiliaryAccountFromOwner(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.aa421Suffix.length
                    );
            } else if (accountingLine.accountableAccount.name.startsWith("425")) {
                auxiliaryAccount.num =
                    this.aa425Suffix +
                    this.getAuxiliaryAccountFromOwner(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.aa425Suffix.length
                    );
            } else if (accountingLine.accountableAccount.name.startsWith("455")) {
                auxiliaryAccount.num =
                    this.aa455Suffix +
                    this.getAuxiliaryAccountFromOwner(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.aa455Suffix.length
                    );
            } else if (accountingLine.accountableAccount.name.startsWith("467")) {
                auxiliaryAccount.num =
                    this.aa467Suffix +
                    this.getAuxiliaryAccountFromOwner(
                        accountingLine,
                        auxiliaryAccount,
                        this.auxiliaryCharacterCount - this.aa467Suffix.length
                    );
            }
        }
        return auxiliaryAccount;
    }

    getAuxiliaryAccountFromThirdPartyCompany(accountingLine, auxiliaryAccount, numLength) {
        let thirdPartyCompany = accountingLine.thirdPartyCompany;
        let auxNum = "";
        if (thirdPartyCompany) {
            auxiliaryAccount.id = thirdPartyCompany.id;
            auxiliaryAccount.thirdPartyCompany = thirdPartyCompany;

            auxiliaryAccount.wording = thirdPartyCompany.shortName || thirdPartyCompany.name;
            if (
                this.enableAuxilaryNames &&
                this.auxiliaries &&
                this.auxiliaries[auxiliaryAccount.wording]
            ) {
                auxNum += (this.auxiliaries[auxiliaryAccount.wording] as string).slice(
                    0,
                    numLength
                );
            } else {
                auxNum += this.getAuxNum(auxiliaryAccount.wording, numLength);
            }
        }
        return auxNum;
    }

    getUserDisplayName(user) {
        if (user) {
            let name = user.firstname || "";
            if (user.lastname) {
                name += name ? " " : "";
                name += user.lastname;
            }
            return name;
        }
        debugger; // git-ignore
        return "";
    }

    getAuxiliaryAccountFromOwner(accountingLine, auxiliaryAccount, numLength) {
        let user = accountingLine.user;
        let auxNum = "";
        if (user && !this.accountableAccountWithUserAsSubAccount) {
            auxiliaryAccount.id = user.id;
            auxiliaryAccount.user = user;

            auxiliaryAccount.wording = this.getUserDisplayName(user);
            if (this.enableUserNames && this.users && this.users[auxiliaryAccount.wording]) {
                auxNum += (this.users[auxiliaryAccount.wording] as string).slice(0, numLength);
            } else {
                auxNum += this.getAuxNum(auxiliaryAccount.wording, numLength);
            }
        }
        return auxNum;
    }

    getAccountableAccountExportName(name) {
        if (this.accountableAccounts && this.accountableAccounts[name]) {
            return (this.accountableAccounts[name] as string).slice(
                0,
                this.auxiliaryCharacterCount
            );
        }
        return "";
    }

    getBankAccountExportName(name) {
        if (this.bankAccounts && this.bankAccounts[name]) {
            return this.bankAccounts[name] as string;
        }
        return name;
    }

    formatTP(data) {
        if (!data) {
            debugger;
            return;
        }
        const auxiliaryItems = [];
        const userItems = [];
        for (const item of data) {
            if (["401", "411"].some((prefix) => item.name.startsWith(prefix))) {
                let accountingLine = {
                    accountableAccount: { name: item.name },
                    thirdPartyCompany: {
                        shortName: "",
                        name: item.thirdPartyCompanyName || "",
                    },
                };
                let exportName = this.getAuxiliaryAccountFromThirdPartyCompany(
                    accountingLine,
                    {},
                    this.getWordingLength(item.name)
                );
                let itemIndex = auxiliaryItems.findIndex(
                    (ai) => ai.thirdPartyCompany === item.thirdPartyCompanyName
                );
                if (itemIndex === -1) {
                    auxiliaryItems.push({
                        name: item.name,
                        thirdPartyCompany: item.thirdPartyCompanyName,
                        type: item.name.startsWith("401") ? "Fournisseur" : "Client",
                        export: exportName,
                        mapped: this.auxiliaries[exportName] ? true : false,
                    });
                } else {
                    if (
                        auxiliaryItems[itemIndex].name.substring(0, 3) !== item.name.substring(0, 3)
                    ) {
                        auxiliaryItems[itemIndex].type = "Fournisseur/Client";
                    }
                }
            } else if (
                ["421", "425", "455", "467"].some((prefix) => item.name.startsWith(prefix))
            ) {
                let accountingLine = {
                    accountableAccount: { name: item.name },
                    user: {
                        firstname: item.firstname || "",
                        lastname: item.lastname || "",
                    },
                };
                let exportName = this.getAuxiliaryAccountFromOwner(
                    accountingLine,
                    {},
                    this.getWordingLength(item.name)
                );
                let displayName = this.getUserDisplayName(accountingLine.user);
                if (!userItems.some((ui) => ui.displayName === displayName)) {
                    userItems.push({
                        name: item.name,
                        firstname: item.firstname || item.thirdPartyCompanyName || "",
                        lastname: item.lastname || "",
                        displayName: displayName,
                        export: exportName,
                        mapped: this.users[exportName] ? true : false,
                    });
                }
            }
        }

        return {
            auxiliaryItems: auxiliaryItems,
            userItems: userItems,
        };
    }

    formatAA(data) {
        let accAccItems = [];
        for (const item of data) {
            let exportName = item.name;
            let mapped = false;
            if (
                this.enableAccAccNames &&
                this.accountableAccounts &&
                this.accountableAccounts[item.name]
            ) {
                exportName = this.accountableAccounts[item.name];
                mapped = true;
            }
            accAccItems.push({
                name: item.name,
                description: item.description,
                export: exportName.substring(0, this.accountableAccountCharacterCount),
                mapped: mapped,
                missingDescription: item.description ? false : true,
            });
        }
        return accAccItems;
    }

    formatBA(data) {
        let bankAccountItems = [];
        for (const item of data) {
            let exportName = item;
            let mapped = false;
            if (this.bankAccounts && this.bankAccounts[item]) {
                exportName = this.bankAccounts[item];
                mapped = true;
            }
            bankAccountItems.push({
                name: item,
                export: exportName,
                mapped: mapped,
            });
        }
        return bankAccountItems;
    }

    getWordingLength(name) {
        let length = this.auxiliaryCharacterCount;
        if (name.startsWith("401")) {
            length -= this.supplierPrefix.length;
        } else if (name.startsWith("411")) {
            length -= this.customerPrefix.length;
        } else if (name.startsWith("421")) {
            length -= this.aa421Suffix.length;
        } else if (name.startsWith("425")) {
            length -= this.aa425Suffix.length;
        } else if (name.startsWith("455")) {
            length -= this.aa455Suffix.length;
        } else if (name.startsWith("467")) {
            length -= this.aa467Suffix.length;
        }
        return length;
    }

    sameOptionsInDB() {
        if (
            this.accountableAccountCharacterCount !==
            this.dbMapping.accountableAccountCharacterCount
        ) {
            this.enableAccAccNames = false;
        }

        if (this.auxiliaryCharacterCount !== this.dbMapping.auxiliaryCharacterCount) {
            this.enableAuxilaryNames = false;
            this.enableUserNames = false;
        } else {
            if (
                !["customerPrefix", "supplierPrefix"].every(
                    (property) => this[property] === this.dbMapping[property]
                )
            ) {
                this.enableAuxilaryNames = false;
            }
            if (
                !["aa421Suffix", "aa425Suffix", "aa455Suffix", "aa467Suffix"].every(
                    (property) => this[property] === this.dbMapping[property]
                )
            ) {
                this.enableUserNames = false;
            }
        }
    }
}
